import { render, staticRenderFns } from "./baseInformation.vue?vue&type=template&id=709be652&scoped=true&"
import script from "./baseInformation.vue?vue&type=script&lang=js&"
export * from "./baseInformation.vue?vue&type=script&lang=js&"
import style0 from "./baseInformation.vue?vue&type=style&index=0&id=709be652&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709be652",
  null
  
)

export default component.exports